import { useEffect, useState } from "react";
import { User } from "../interfaces/User";
import keycloak, { getSubscription } from "../config/keycloak";
import UserSettingService from "../services/userSettingService";

export const Profile = () => {
  const userService = new UserSettingService();
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const loadUser = async () => {
      const user = await userService.getUser();
      setUser(user);
    };

    loadUser();
  }, []);

  return (
      <div className="flex flex-col items-center justify-center px-6 md:px-10 text-gray-900">
        <div className="w-full max-w-3xl bg-white rounded-2xl shadow-lg border border-gray-100 p-8 md:p-10">
          <h1 className="text-4xl font-bold text-center mb-8">
            Mein Profil
          </h1>

          <p className="text-lg text-gray-600 text-center mb-10">
            Behalte deine Ackerplus-Mitgliedschaft im Überblick.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Benutzername */}
            <div className="flex flex-col">
              <label htmlFor="username" className="text-sm font-semibold text-gray-700 mb-1">
                🧑 Benutzername
              </label>
              <input
                type="text"
                id="username"
                value={keycloak.tokenParsed?.preferred_username || ""}
                readOnly
                className="py-2.5 px-4 w-full rounded-lg bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#37813b]"
              />
            </div>

            {/* Email */}
            <div className="flex flex-col">
              <label htmlFor="email" className="text-sm font-semibold text-gray-700 mb-1">
                📧 E-Mail
              </label>
              <input
                type="text"
                id="email"
                value={keycloak.tokenParsed?.email || ""}
                readOnly
                className="py-2.5 px-4 w-full rounded-lg bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#37813b]"
              />
            </div>

            {/* Subscription */}
            <div className="flex flex-col">
              <label htmlFor="subscription" className="text-sm font-semibold text-gray-700 mb-1">
                📦 Plan
              </label>
              <input
                type="text"
                id="subscription"
                value={getSubscription() || "Free"}
                readOnly
                className="py-2.5 px-4 w-full rounded-lg bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#37813b]"
              />
            </div>

            {/* Gültig bis */}
            <div className="flex flex-col">
              <label htmlFor="subscription-validity" className="text-sm font-semibold text-gray-700 mb-1">
                🗓️ Gültig bis
              </label>
              <input
                type="text"
                id="subscription-validity"
                value={
                  user?.validUntil
                    ? new Date(user.validUntil).toLocaleDateString("de-CH", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                    : "-"
                }
                readOnly
                className="py-2.5 px-4 w-full rounded-lg bg-gray-50 border border-gray-200 text-gray-800 focus:outline-none focus:ring-2 focus:ring-[#37813b]"
              />
            </div>
          </div>

          <div className="flex justify-center mt-10">
            {!keycloak.authenticated ? (
              <button
                onClick={() =>
                  keycloak.login({ redirectUri: window.location.origin + "/map" })
                }
                className="bg-[#2F4F2F] hover:bg-[#37813b] text-white font-medium py-2.5 px-8 rounded-lg transition-colors"
              >
                Login
              </button>
            ) : (
              <button
                onClick={() => keycloak.logout({ redirectUri: window.location.origin })}
                className="bg-[#2F4F2F] hover:bg-[#37813b] text-white font-medium py-2.5 px-8 rounded-lg transition-colors"
              >
                Abmelden
              </button>
            )}
          </div>

          <div className="mt-6 text-center text-sm text-gray-500">
            Letzte Anmeldung:{" "}
            {keycloak.tokenParsed?.auth_time
              ? new Date(keycloak.tokenParsed.auth_time * 1000).toLocaleString("de-CH")
              : "–"}
          </div>
        </div>
      </div>
  );
};
